import { handleActions } from 'redux-actions'

import { SessionNamingConventionType } from '@tabeeb/enums'

import { openTenantFormsDialog, closeTenantFormsDialog } from '../actions'

const defaultState: {
  open: boolean
  sncType?: SessionNamingConventionType
  subdomain?: string | null
} = {
  open: false,
  sncType: undefined,
}

export default handleActions<typeof defaultState, any>(
  {
    [openTenantFormsDialog.toString()](state, { payload }) {
      return { ...state, open: true, sncType: payload.sncType, subdomain: payload.subdomain }
    },
    [closeTenantFormsDialog.toString()](state) {
      return { ...state, open: false }
    },
  },
  defaultState
)
